export default {
  '.bp3-datepicker .DayPicker-Day.DayPicker-Day--selected': {
    backgroundColor: 'blue.500',
    _hover: {
      backgroundColor: 'blue.500',
    },
  },
  '.bp3-datepicker-footer': {
    flexDirection: 'row-reverse',
  },
  '.bp3-datepicker-footer .bp3-button:first-of-type': {
    color: 'blue.500',
  },
}
